import type { AxiosResponse } from 'axios'

import type {
    CertificateApprovalDetail,
    CertificateApprovalsListResponse,
    UpdateCertificateApprovalPayload
} from '@/api/modules/certificateApprovalsQueries'
import certificateApprovalsQueries from '@/api/modules/certificateApprovalsQueries'
import jobsQueries from '@/api/modules/jobsQueries'
import type { JobPapersListResponseSchema } from '@/api/schemas/jobs/jobs'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

async function fetchCertificateApprovals(queryString = ''): Promise<AxiosResponse<CertificateApprovalsListResponse>> {
    try {
        return await certificateApprovalsQueries.fetchCertificateApprovals(queryString)
    } catch (error) {
        handleApiError(error, t('quality.certificateApprovals.errors.fetchList'))
        throw error
    }
}

async function fetchCertificateApproval(approvalId: number | string): Promise<AxiosResponse<CertificateApprovalDetail>> {
    try {
        return await certificateApprovalsQueries.fetchCertificateApproval(approvalId)
    } catch (error) {
        handleApiError(error, t('quality.certificateApprovals.errors.fetchDetail'))
        throw error
    }
}

async function updateCertificateApproval(
    approvalId: number | string,
    payload: UpdateCertificateApprovalPayload
): Promise<AxiosResponse<CertificateApprovalDetail>> {
    try {
        const response = await certificateApprovalsQueries.updateCertificateApproval(approvalId, payload)
        notificationService.success(t('quality.certificateApprovals.notifications.saveSuccess'))
        return response
    } catch (error) {
        handleApiError(error, t('quality.certificateApprovals.errors.save'))
        throw error
    }
}

async function fetchCertificateApprovalPapers(): Promise<AxiosResponse<JobPapersListResponseSchema>> {
    try {
        return await jobsQueries.fetchPapers()
    } catch (error) {
        handleApiError(error, t('quality.certificateApprovals.errors.fetchPapers'))
        throw error
    }
}

export const certificateApprovalsService = {
    fetchCertificateApprovals,
    fetchCertificateApproval,
    updateCertificateApproval,
    fetchCertificateApprovalPapers
}
